import { request } from '@/shared'

export const sendFeedback = (rate: number, comment?: string) => request('post', '/feedback', { rate, comment })
